export const real = () => {
    console.log('pixel init');

    !(function (f, b, e, v, n, t, s) {
        n = f.fbq = function () {
            n.callMethod
                ? n.callMethod.apply(n, arguments)
                : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        t.id = 'pixel-script';
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js'
    );
    fbq('init', '1519016608242813');
    fbq('track', 'PageView');
};

export const mock = () => {
    const script = document.querySelector('#pixel-script');
    if (script) {
        script.parentNode.removeChild(script);
    }
    window.fbq = (...args) => console.log('fbq', args);
};

mock();
